<div class="grid grid--va-middle mt-24">
  <div class="grid__box grid__box--size-min">
    <span class="title"> Массов. действия </span>
  </div>
  <div class="grid__box grid__box--size-min">
    <div class="grid grid--gap-8 grid--va-middle">
      <div class="grid__box grid__box--size-min">
        <app-combobox
          [items]="ticketsMultipleAssign.brigades"
          (callback)="ticketsMultipleAssign.onChangeBrigadeForAssigment($event)"
          [textKey]="'brigade_name_merged'"
          [defaultText]="'Выберите бригаду'"
          [initBy]="ticketsMultipleAssign.brigadeSelected"
          [name]="'brigadeNameAssign'"
        ></app-combobox>
      </div>
      <div class="grid__box grid__box--size-min">
        <button
          class="button"
          type="button"
          id="appAssignBrigade"
          (click)="ticketsMultipleAssign.onAddTicketsToBrigades()"
          [disabled]="!ticketsMultipleAssign.brigadeSelected || !ticketsMultipleAssign.isExistCheckedTicket"
        >
          Назначить
        </button>
      </div>
    </div>
  </div>
  <div class="grid__box grid__box--size-min">
    <a class="link link--dotted" (click)="onResetCheckedTickets()">Снять выделение с заявок </a>
  </div>
  <div class="grid__box grid__box--pull-right grid__box--flex grid__box--justify-content-flex-end">
    <div class="grid grid--va-middle">
      <div class="grid__box grid__box--size-min">
        <div class="grid grid--va-middle grid--gap-4">
          <div class="grid__box grid__box--size-min">
            <app-icon [glyph]="'update'" [size]="'16'" [class]="'icon--va-middle'" [color]="'gray-dark'"></app-icon>
          </div>
          <div class="grid__box grid__box--size-min">
            <a class="link link--dotted-blue-dark" (click)="ticketsListRefresh()">Обновить список заявок</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
